<template>
  <collapse
    id="historic-departures-panel"
    :collapse="years"
    icon="keyboard_arrow_down"
    color-collapse="primary"
  >
    <div
      v-for="(deps, index) in departures"
      :key="index"
      :slot="`md-collapse-pane-${index + 1}`"
      class="historic_year"
    >
      <div
        v-for="departure in deps"
        :key="departure.id"
        class="md-layout historic_year_data"
      >
        <div class="md-layout-item md-size-5 status">
          <i
            v-if="departure.status.key == 'Confirmed'"
            class="far fa-calendar-check text-success"
          >
            <md-tooltip md-direction="top"
              >This Departure is Confirmed</md-tooltip
            >
          </i>
          <i v-else class="far fa-calendar-times text-danger"
            ><md-tooltip md-direction="top"
              >This Departure is <strong>NOT</strong> Confirmed</md-tooltip
            ></i
          >
        </div>
        <div class="md-layout-item md-size-45 start_date">
          {{ departure.start_date | formatDate }}
        </div>
        <div class="md-layout-item md-size-40 stats">
          {{ departure.bookings_count }} bookings |
          {{ departure.num_passengers }} passengers
        </div>
        <div class="md-layout-item md-size-10 text-right actions">
          <md-button
            :to="{
              name: 'Departure Profile',
              params: { departure_id: departure.id }
            }"
            class="md-success md-just-icon md-simple"
          >
            <md-icon>visibility</md-icon>
            <md-tooltip md-direction="top">View this Departure</md-tooltip>
          </md-button>
        </div>
      </div>
    </div>
  </collapse>
</template>
<script>
import { Collapse } from "@/components";

export default {
  name: "TourTabsDeparturesHistoricPanel",
  props: ["departuresByYear"],

  data() {
    return {};
  },

  components: { Collapse },

  computed: {
    years() {
      return Object.keys(this.departuresByYear);
    },
    departures() {
      return Object.values(this.departuresByYear);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
#historic-departures-panel {
  &::v-deep .md-collapse-label {
    padding: 15px 10px 10px 0;
    &::after {
      bottom: 4px;
    }
    .md-collapse-title .md-icon {
      bottom: 14px;
    }
  }

  .historic_year {
    border-bottom: 1px solid $grey-500;
    padding: 5px 0;

    .historic_year_data {
      align-content: center;

      .md-layout-item {
        align-content: center;
      }
    }

    .md-button.md-just-icon {
      width: 25px;
      height: 25px;
    }

    h6 {
      margin: 0.3em 0;
      font-size: 1.2em;
    }

    .status {
      width: 30px;
    }
  }
}
</style>
